import { Component, OnInit, Inject } from '@angular/core';

import { MessageCrudService } from '@evomatik/evk-common';


import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RechazarDiligenciaService } from '../services/rechazar-diligencia.service';

@Component({
  selector: 'app-motivo-rechazo',
  templateUrl: './motivo-rechazo.component.html',
  styleUrls: ['./motivo-rechazo.component.scss']
})
export class MotivoRechazoComponent implements OnInit {
    observaciones = new FormControl('', Validators.required);
    

  constructor(
      public messageCrudService: MessageCrudService,
      public dialogRef: MatDialogRef<MotivoRechazoComponent>,
      private rechazarService: RechazarDiligenciaService,
      @Inject(MAT_DIALOG_DATA)
      public data: any
  ) { }

  ngOnInit() {
  }
    public save(){
        const diligencia = this.data;
        diligencia['motivoEstado'] = this.observaciones.value;
        const dialog = this.messageCrudService.openConfirmDialog({warn: `Está seguro de que desea rechazar está diligncia`});
        dialog.componentInstance.resolveEvent.subscribe(() => {
            dialog.close();
            this.rechazarService.edit(diligencia).subscribe(
                (response) => {
                    this.messageCrudService.snackbarSuccess(response, null);
                    this.dialogRef.close(response.data);
                },
                (error) => {
                    this.dialogRef.close(false);
                    this.messageCrudService.snackbarError(error);
                }
            );
        });
    }

}
